<mat-card class="cur-card">
  <mat-card-content>
    <mat-tab-group animationDuration="2000ms" style="width: 100%;" id="tabGroup">

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">bookmark</mat-icon>
          事前確認
        </ng-template>
        <app-sgke360d-pre-check [suppntInfo]="suppntInfo" [codeMap]="codeMap" [adconfirmTab]="tabArea.adconfirmTab"
          (updateEvent)="tabUpdate()"></app-sgke360d-pre-check>
      </mat-tab>

      <mat-tab *ngIf="enabledGuidingvalueInput">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">bookmark</mat-icon>
          指針入力
        </ng-template>
        <app-sgke360d-guidingvalue-input [shishinInputTab]="tabArea.shishinInputTab"
          (onModalIsDisplayEvent)="onModalIsDisplayEvent.emit($event)">
        </app-sgke360d-guidingvalue-input>
      </mat-tab>

      <mat-tab *ngIf="enabledInspectionTreatment" name="inspectionTreatmentTab">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">bookmark</mat-icon>
          点検・処置
        </ng-template>
        <app-sgke360d-inspection-treatment [suppntInfo]="suppntInfo" [codeMap]="codeMap"
          [inspectionTreatmentTab]="tabArea.inspectionTreatmentTab" [shishinInputTab]="shishinInputTab">
        </app-sgke360d-inspection-treatment>
      </mat-tab>

      <mat-tab *ngIf="enabledSafetyKnowledge">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">bookmark</mat-icon>
          安全周知
        </ng-template>
        <app-sgke360d-safety [safenoticeTab]="tabArea.safenoticeTab" [codeMap]="codeMap">
        </app-sgke360d-safety>
      </mat-tab>

      <mat-tab *ngIf="enabledLastConfirmation">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">bookmark</mat-icon>
          最終確認
        </ng-template>
        <app-sgke360d-last-confirmation [suppntInfo]="suppntInfo" [finalConfirmTab]="tabArea.finalConfirmTab"
          [codeMap]="codeMap"(drawFlgEvent)="drawFlgEvent.emit($event)">
        </app-sgke360d-last-confirmation>
      </mat-tab>

    </mat-tab-group>
    <!-- 供給再開結果登録画面_作業結果・日時情報 -->
    <app-sgke360d-results [workResultArea]="initResponse.initialhyojiInfo.workResultArea" [codeMap]="codeMap">
    </app-sgke360d-results>
    <!-- 供給停止結果登録画面_ボタンエリア -->
    <mat-card-actions>
      <app-sgke360d-button-area [suppntInfo]="suppntInfo" (onClickButtonEvent)="onClickButtonEvent.emit($event)">
      </app-sgke360d-button-area>
    </mat-card-actions>
  </mat-card-content>
</mat-card>